module.exports = __webpack_public_path__ + "static/img/44-5.51fa579.png";